// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/fonts/iconfont.css'

import $ from 'jquery'
// 引入axios
import axios from 'axios';
// 挂载到vue原型链上
Vue.prototype.axios = axios;



/*import 'lib-flexible'
import 'util/flexible'*/

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'



Vue.use(ElementUI);



Vue.config.productionTip = false

Vue.component('menu-item', {
  props: ['item'],
  template: `
    <div>
      <el-submenu v-if="item.children" :index="item.id">
        <template #title>
          {{ item.label }}
        </template>
        <template v-for="childItem in item.children">
          <menu-item :item="childItem" :key="childItem.id"></menu-item>
        </template>
      </el-submenu>
      <el-menu-item v-else :index="item.id">
        {{ item.label }}
      </el-menu-item>
    </div>
  `
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js